import React, { useEffect } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import isEmpty from 'lodash/isEmpty';
import { fetchPlacements } from 'core/actions/ocapi';
import ComponentErrorBoundary from 'core/modules/ErrorBoundaries/ComponentErrorBoundary';
import SectionTitle from 'core/modules/SectionTitle/SectionTitle';
import { selectSiteUrl } from 'core/selectors/app';
import { selectActiveMQ, selectIsMobileMQ } from 'core/modules/MediaQueries/selectors';
import ContentWrap from 'core/modules/Partials/ContentWrap/ContentWrap';
import List from 'core/modules/Partials/List/List';
import MerchantTileListItem from 'core/modules/MerchantTileList/components/MerchantTileListItem/MerchantTileListItem';
import {
  selectEarnStoresConfig, selectEarnStoresIsLoading, selectEarnStoresIsLoaded, selectEarnStoresRecords,
} from './selectors';

import './EarnStores.scss';

function EarnStores() {
  const siteUrl = useSelector(selectSiteUrl);
  const activeMQ = useSelector(selectActiveMQ);
  const isMobileMQ = useSelector(selectIsMobileMQ);
  const isLoaded = useSelector(selectEarnStoresIsLoaded);
  const isLoading = useSelector(selectEarnStoresIsLoading);
  const config = useSelector(selectEarnStoresConfig);
  const merchants = useSelector(selectEarnStoresRecords);
  const dispatch = useDispatch();

  useEffect(() => {
    if (!isLoaded && !isLoading) {
      const { api: { options, params } } = config;
      dispatch(fetchPlacements(params, options));
    }
  }, []);

  const {
    useCarouselOnMediaQueriesOnly = [], secTitle, viewAllLinkCTAText, carousel,
  } = config;
  const shouldUseCarousel = useCarouselOnMediaQueriesOnly.includes(activeMQ);

  if (isEmpty(merchants)) {
    return null;
  }

  return (
    <div className="mn_earnStores">
      <ContentWrap>
        <SectionTitle title={secTitle}>
          {!isMobileMQ && <a className="mn_viewAllLink" href={`${siteUrl}/b____.htm`}>View all stores</a>}
        </SectionTitle>
        <List shouldUseCarousel={shouldUseCarousel} options={carousel}>
          {merchants.map(merchant => (
            <MerchantTileListItem key={merchant.id} merchant={merchant} />
          ))}
        </List>
        { isMobileMQ &&
        <a className="mn_button mn_secondaryButton mn_seeAllButton" href={`${siteUrl}/b____.htm`}>
          {viewAllLinkCTAText}
        </a> }
      </ContentWrap>
    </div>
  );
}

export default (props) => <ComponentErrorBoundary><EarnStores {...props} /></ComponentErrorBoundary>;
